export const enum Roles {
  PORTAL_GERENCIAR_BIBLIOTECA = 'PORTAL_GERENCIAR_BIBLIOTECA',
  PORTAL_MANUTENCAO_DEALERS_GRUPO = 'PORTAL_MANUTENCAO_DEALERS_GRUPO',
  PORTAL_MANUTENCAO_USUARIOS = 'PORTAL_MANUTENCAO_USUARIOS',
  PORTAL_CONSULTA_VISUALIZACAO_USUARIOS = 'PORTAL_CONSULTA_VISUALIZACAO_USUARIOS',
  PORTAL_MANUTENCAO_GRUPOS_USUARIOS = 'PORTAL_MANUTENCAO_GRUPOS_USUARIOS',
  PORTAL_APROVACAO_ENVIO_COMUNICADOS = 'PORTAL_APROVACAO_ENVIO_COMUNICADOS',
  PORTAL_CRIACAO_COMUNICADOS = 'PORTAL_CRIACAO_COMUNICADOS',
  PORTAL_MANUTENCAO_SLIDES = 'PORTAL_MANUTENCAO_SLIDES',
  PORTAL_MANUTENCAO_ANUNCIOS = 'PORTAL_MANUTENCAO_ANUNCIOS',
  PORTAL_NOTIFICACOES_GENERICAS = 'PORTAL_NOTIFICACOES_GENERICAS',
  PORTAL_MANUTENCAO_MODELO = 'PORTAL_MANUTENCAO_MODELO',
  LIBERAR_ATIVACAO_ESPECIAL = 'LIBERAR_ATIVACAO_ESPECIAL',
  PORTAL_IMPORTACAO_USUARIOS = 'PORTAL_IMPORTACAO_USUARIOS',
  PORTAL_ADMINISTRATIVO_TECSINAPSE = 'PORTAL_ADMINISTRATIVO_TECSINAPSE',
  PORTAL_CRIACAO_GRUPOS_USUARIOS_PUBLICOS = 'PORTAL_CRIACAO_GRUPOS_USUARIOS_PUBLICOS',
  RELATORIOS_PORTAL_CONSULTA_PECAS = 'RELATORIOS_PORTAL_CONSULTA_PECAS',
  PORTAL_AUSENCIA_TEMPORARIA = 'PORTAL_AUSENCIA_TEMPORARIA',
  PORTAL_INATIVACAO_DEALERS_GRUPO = 'PORTAL_INATIVACAO_DEALERS_GRUPO'
}
